import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const { t } = useTranslation();
  const { verifyEmail } = useAuth();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("loading");
  const ran = useRef(false);

  useEffect(() => {
    const token = sp.get("token");
    if (!token) { setStatus("error"); return; }
    if (ran.current) return;
    ran.current = true;
    verifyEmail(token)
      .then(() => { setStatus("ok"); setTimeout(() => nav("/app/employer", { replace: true }), 1400); })
      .catch(() => setStatus("error"));
  }, []);

  return (
    <AuthShell title={t("vrf.title")} testid="verify-email-page">
      <div className="text-center" data-testid="verify-email-status">
        {status === "loading" && <Loader2 className="mx-auto h-8 w-8 animate-spin text-cyan-dark" />}
        {status === "ok" && <><CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" /><p className="mt-3 text-sm text-slate-600">{t("vrf.ok")}</p></>}
        {status === "error" && <><XCircle className="mx-auto h-10 w-10 text-red-500" /><p className="mt-3 text-sm text-slate-600">{t("vrf.err")}</p><Link to="/login" className="mt-3 inline-block text-sm font-semibold text-cyan-dark hover:underline">{t("vrf.toLogin")}</Link></>}
      </div>
    </AuthShell>
  );
}
